module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-4.jpg?c02a3a7a";